function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

/*
function cleanupFormatting_blockquote(sel){
	return;
	var text = $(sel).html();
	text = text.replace("<blockquote>", '<div class="blockquote_holder"><blockquote>');
	text = text.replace("</blockquote>", '</blockquote></div>');
	$(sel).html(text);
}
*/

function getQsParamByName(name){
  name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.search);
  if(results == null) {
    return "";
  } else {
    return decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}


function vimeo_responsive(){
	$(".vimeo_aspect").each(function(i, el){
		var aspect = $(el).attr("data-aspect");
		var new_hei = $(el).width()/aspect;
		$(el).css({ height:new_hei+"px" });
	});
}

function getCookieValue(a, b) {
    b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

function setCookieValue(name,value,seconds) {
    var expires = "";
    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + (seconds*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function _eventAdd(event_name, handler, event_data){
	$(document).bind(event_name, event_data, handler);
}

function _eventFire(event_name, param){
  if (!param) {
    param = null;
  }
	$(document).triggerHandler(event_name, param);
}



String.prototype.toHHMMSS = function () {
  var sec_num = parseInt(this, 10); // don't forget the second param
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  var time = hours + ':' + minutes + ':' + seconds;
  return time;
};
